export default __webpack_public_path__ + "mytributes/images/fallback3.jpg";